import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { OnlineReceiversQuery, OnlineReceiversQueryHandlerBase } from '@skylab-shared/business';
export { OnlineReceiversQueryHandlerBase };

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(OnlineReceiversQuery)
@Wrapper(OnlineReceiversQueryHandlerBase)
export class OnlineReceiversQueryHandler {
    public constructor(
        http: Http
    ) {
    }
}
